import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button, TextField, Typography} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import React, {useContext} from "react";
import {useNavigate} from "react-router-dom";
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {config} from "../../../constant";
import UserContext from "../../../UserContext";

export default function DialogEditCommentCategory({open, onClose, comment, nomination}) {
    const {user, setUser} = useContext(UserContext);
    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        content: Yup.string().required("Commentaire est obligatoire")
    });

    const {register, reset, control, handleSubmit, formState: {errors}} = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: comment ? {
            content: comment.content
        } : {
            content: ''
        }
    });

    const onSubmit = (data) => {
        const newComment = {
            id: comment ? comment.id : null,
            content: data.content,
            nomination: nomination,
            author: user
        };
        const requestOptions = {
            method: comment ? 'PUT' : 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(newComment)
        };
        fetch(`${config.BASE_URL}/comments`, requestOptions)
            .then(response => {
                console.log(response.status);
                onClose(true);
            })
            .catch((error) => {
                const message = 'Erreur dans la création d\'un commentaire';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    return (
        <Dialog open={open} onClose={() => onClose(false)} maxWidth={'lg'}>
            <DialogTitle>Commentaire</DialogTitle>
            <DialogContent>
                <form id="commentForm" onSubmit={handleSubmit(onSubmit)}>
                    <TextField
                        margin="dense"
                        id="content"
                        name="content"
                        label="Commentaire"
                        fullWidth
                        variant="standard"
                        multiline
                        maxRows={Infinity}
                        {...register("content")}
                        error={!!errors.content}
                    />
                    <Typography variant="inherit" color="textSecondary">{errors.content?.message}</Typography>
                </form>
            </DialogContent>
            <DialogActions>
                <Button type="submit" form="commentForm">OK</Button>
                <Button onClick={() => onClose(false)}>Annuler</Button>
            </DialogActions>
        </Dialog>
    );
}
